import { migrateFontBoldStyleToFontWeightMutably } from '../../../services/compat/migration.helpers';
import {
  type LayoutMigration,
  type LayoutMigrationContext,
} from '../../../services/compat/migrations/layout-migration.models';
import { type ButtonElement } from '../button.element';

export const buttonV2AddActionPropsMigration: LayoutMigration = {
  mode: 'layout',
  description: 'Add accessibility properties to button element',
  run: (button: ButtonElement, context: LayoutMigrationContext): void => {
    const { layoutSnapshot } = context;
    const buttonProps = button.props;
    const clickConnection = layoutSnapshot.actionLayer.connections.find(
      (c) =>
        c.eventType === 'click' &&
        c.source.layerType === 'Ui' &&
        c.source.id === button.id &&
        c.target.layerType === 'Workflow',
    );
    if (!buttonProps?.content?.action?.workflowId && clickConnection) {
      buttonProps.content = {
        ...buttonProps.content,
        action: {
          ...buttonProps.content?.action,
          workflowId: clickConnection.target.id,
        },
      };
    }
    if (button.height?.fixed) {
      delete button.height.fixed;
    }
    migrateFontBoldStyleToFontWeightMutably(buttonProps.style?.font);
  },
};
